module.exports = __webpack_public_path__ + "sj.svg?063d1a48a4d4125072549919ad57e6da";